export var INIT_SRE = "INIT_SRE";
export var ENABLE_AUDIO_LOG = "ENABLE_AUDIO_LOG";
export var INIT_SRE_SUCCESS = "INIT_SRE_SUCCESS";
export var SRE_LOAD_STATUS = "SRE_LOAD_STATUS";
export var INIT_SRE_FAILURE = "INIT_SRE_FAILURE";
export var SRE_LISTEN_FOR_PHRASES = "SRE_LISTEN_FOR_PHRASES";
export var SRE_LISTEN_FOR_PHRASE_RESULT = "SRE_LISTEN_FOR_PHRASE_RESULT";
export var SRE_LISTEN_FOR_PHRASES_ERROR = "SRE_LISTEN_FOR_PHRASES_ERROR";
export var SRE_LISTEN_FOR_PHRASES_RESET_WORDS_RESULT_CACHE = "SRE_LISTEN_FOR_PHRASES_RESET_WORDS_RESULT_CACHE";

export var SRE_CHECK_MIC = "SRE_CHECK_MIC";

export var SRE_CALIBRATE_START = "SRE_CALIBRATE_START";
export var SRE_CALIBRATE_COMPLETE = "SRE_CALIBRATE_COMPLETE";
export var SRE_CALIBRATE_ERROR = "SRE_CALIBRATE_ERROR";

export var SRE_OPEN_CALIBRATE_WIN = "SRE_OPEN_CALIBRATE_WIN";
export var SRE_CLOSE_CALIBRATE_WIN = "SRE_CLOSE_CALIBRATE_WIN";

export var SRE_AUDIO_LEVEL = "SRE_AUDIO_LEVEL";
export var SRE_MIC_ACCESS = "SRE_MIC_ACCESS";
export var SRE_MIC_LIST = "SRE_MIC_LIST";
export var SRE_REFRESH_MIC_LIST = "SRE_REFRESH_MIC_LIST";
export var SRE_SET_CURRENT_MIC = "SRE_SET_CURRENT_MIC";
export var SRE_MIC_CHOSEN = "SRE_MIC_CHOSEN";
export var SRE_HYPOTHESIS = "SRE_HYPOTHESIS";
export var SRE_LISTEN_FOR_PHRASES_UPDATE = "SRE_LISTEN_FOR_PHRASES_UPDATE";
export var SRE_CANCEL_SESSION = "SRE_CANCEL_SESSION";
export var SRE_SPEECH_DISABLE = "SRE_SPEECH_DISABLE";
export var SRE_INSTALL_MIC = "SRE_INSTALL_MIC";

export var SRE_CALIBRATE_HELP = "SRE_CALIBRATE_HELP";
export var SRE_CALIBRATE_CLOSE_HELP = "SRE_CALIBRATE_CLOSE_HELP";

export var SRE_ABORT_LISTEN = "SRE_ABORT_LISTEN";

export var SRE_RESET_PROMPT_RESULT = "SRE_RESET_PROMPT_RESULT";
export var SRE_ENABLE_FAKE = "SRE_ENABLE_FAKE";

export var SRE_SONIC_LOAD_COMPLETE = "SRE_SONIC_LOAD_COMPLETE";
export var SRE_SPEECH_MODEL_LOAD_COMPLETE = "SRE_SPEECH_MODEL_LOAD_COMPLETE";

export var SRE_LOAD_SONIC_LIBRARY = "SRE_LOAD_SONIC_LIBRARY";
export var SRE_LOAD_SPEECH_MODEL = "SRE_LOAD_SPEECH_MODEL";
export var SRE_BEGIN_LOADING = "SRE_BEGIN_LOADING";

export var SRE_CONFIRM_MIC_ACCESS = "SRE_CONFIRM_MIC_ACCESS";
export var SRE_START_MIC_CHECK_FLOW = "SRE_START_MIC_CHECK_FLOW";
export var SRE_SHOW_BROWSER_MIC_BLOCK_MODAL = "SRE_SHOW_BROWSER_MIC_BLOCK_MODAL";
export var SRE_USER_ACKNOWLEDGES_BROWSER_MIC_BLOCK_MODAL = "SRE_USER_ACKNOWLEDGES_BROWSER_MIC_BLOCK_MODAL";
export var ACKNOWLEDGED_MIC_BLOCKED = "ACKNOWLEDGED_MIC_BLOCKED";
export var FIXED_MIC_BLOCKED = "FIXED_MIC_BLOCKED";

export var SET_VERSION = "SET_VERSION";
export var SRE_SKIP_MIC_CALIBRATION = "SRE_SKIP_MIC_CALIBRATION";

export var SRE_RESET_RECENTLY_SAVED_SOUND_LOG_IDS_CACHE = "SRE_RESET_RECENTLY_SAVED_SOUND_LOG_IDS_CACHE";

export var confirmMicAccess = function confirmMicAccess() {
  return { type: SRE_CONFIRM_MIC_ACCESS };
};
export var startMicCheckFlow = function startMicCheckFlow() {
  return { type: SRE_START_MIC_CHECK_FLOW };
};
export var sreBeginLoading = function sreBeginLoading() {
  return { type: SRE_BEGIN_LOADING };
};
export var disableSpeech = function disableSpeech() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: SRE_SPEECH_DISABLE,
    payload: { enabled: enabled }
  };
};
export var enableSpeech = function enableSpeech() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    type: SRE_SPEECH_DISABLE,
    payload: { enabled: enabled }
  };
};
export var sreHypothesis = function sreHypothesis(phrase) {
  return {
    type: SRE_HYPOTHESIS,
    payload: phrase
  };
};
export var sreListenForPhrasesUpdate = function sreListenForPhrasesUpdate(payload) {
  return {
    type: SRE_LISTEN_FOR_PHRASES_UPDATE,
    payload: payload
  };
};
export var initSRE = function initSRE() {
  var srePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/sre/";
  var sonicWorkerUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    type: INIT_SRE,
    payload: { srePath: srePath, sonicWorkerUrl: sonicWorkerUrl }
  };
};
export var onSRESuccess = function onSRESuccess() {
  return { type: INIT_SRE_SUCCESS, payload: {} };
};
export var onSRELoadStatus = function onSRELoadStatus(percent) {
  return {
    type: SRE_LOAD_STATUS,
    payload: percent
  };
};
export var onSRELoadFailure = function onSRELoadFailure(error) {
  return {
    type: INIT_SRE_FAILURE,
    payload: error
  };
};
export var sreAudioLevel = function sreAudioLevel(level) {
  return {
    type: SRE_AUDIO_LEVEL,
    payload: level
  };
};
export var startCalibrate = function startCalibrate() {
  return { type: SRE_CALIBRATE_START };
};
export var calibrateComplete = function calibrateComplete(qualityStr) {
  return {
    type: SRE_CALIBRATE_COMPLETE,
    payload: { qualityStr: qualityStr }
  };
};
export var calibrateError = function calibrateError(error) {
  return {
    type: SRE_CALIBRATE_ERROR,
    payload: { error: error }
  };
};
export var listMics = function listMics(microphones) {
  return {
    type: SRE_MIC_LIST,
    payload: microphones
  };
};
export var refreshMicList = function refreshMicList() {
  return { type: SRE_REFRESH_MIC_LIST };
};
export var listenForPhrases = function listenForPhrases(phrases, promptId) {
  var scoreThreshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var useLFOP = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return {
    type: SRE_LISTEN_FOR_PHRASES,
    payload: { phrases: phrases, promptId: promptId, scoreThreshold: scoreThreshold, duration: duration, useLFOP: useLFOP }
  };
};
export var listenForPhrasesError = function listenForPhrasesError(errorState, errorMessage) {
  return {
    type: SRE_LISTEN_FOR_PHRASES_ERROR,
    payload: { errorState: errorState, errorMessage: errorMessage }
  };
};
export var listenForPhraseResult = function listenForPhraseResult(promptId, result) {
  var canceled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var silence = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var passed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var error = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var wordResult = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var audioQualityMetrics = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var saveSoundLogID = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var tooLoud = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
  var tooSoft = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
  var tooMuchBackgroundNoise = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : false;
  return {
    type: SRE_LISTEN_FOR_PHRASE_RESULT,
    payload: {
      promptId: promptId,
      result: result,
      canceled: canceled,
      silence: silence,
      passed: passed,
      wordResult: wordResult,
      audioQualityMetrics: audioQualityMetrics,
      saveSoundLogID: saveSoundLogID,
      tooLoud: tooLoud,
      tooSoft: tooSoft,
      tooMuchBackgroundNoise: tooMuchBackgroundNoise
    }
  };
};

export var resetListenForPhrasesWordCache = function resetListenForPhrasesWordCache() {
  return { type: SRE_LISTEN_FOR_PHRASES_RESET_WORDS_RESULT_CACHE };
};
export var resetSREPromptResult = function resetSREPromptResult(promptId) {
  return {
    type: SRE_RESET_PROMPT_RESULT,
    payload: { promptId: promptId }
  };
};
export var setCurrentMic = function setCurrentMic() {
  return { type: SRE_SET_CURRENT_MIC };
};
export var checkMicAccess = function checkMicAccess() {
  return { type: SRE_CHECK_MIC };
};
export var micAccess = function micAccess(status) {
  return { type: SRE_MIC_ACCESS, payload: status };
};
export var installMic = function installMic(micToInstall) {
  return { type: SRE_INSTALL_MIC, payload: { micToInstall: micToInstall } };
};
export var micChosen = function micChosen(mic) {
  return { type: SRE_MIC_CHOSEN, payload: mic };
};
export var cancelSRESession = function cancelSRESession() {
  return { type: SRE_CANCEL_SESSION };
};
export var calibrateSRE = function calibrateSRE() {
  var exitOnCancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var srePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/sre/";
  var sonicWorkerUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var exitOnDisableSpeech = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return {
    type: SRE_OPEN_CALIBRATE_WIN,
    payload: { exitOnCancel: exitOnCancel, srePath: srePath, sonicWorkerUrl: sonicWorkerUrl, exitOnDisableSpeech: exitOnDisableSpeech }
  };
};
export var closeCalibrateWindow = function closeCalibrateWindow() {
  return { type: SRE_CLOSE_CALIBRATE_WIN };
};
export var openCalibrateHelp = function openCalibrateHelp() {
  return { type: SRE_CALIBRATE_HELP };
};
export var closeCalibrateHelp = function closeCalibrateHelp() {
  return { type: SRE_CALIBRATE_CLOSE_HELP };
};
export var abortSREListen = function abortSREListen() {
  return { type: SRE_ABORT_LISTEN };
};
export var enableFakeSRE = function enableFakeSRE() {
  return { type: SRE_ENABLE_FAKE };
};
export var sonicLoadComplete = function sonicLoadComplete() {
  return { type: SRE_SONIC_LOAD_COMPLETE };
};
export var speechModelLoadComplete = function speechModelLoadComplete(modelLoaded) {
  return {
    type: SRE_SPEECH_MODEL_LOAD_COMPLETE,
    payload: { modelLoaded: modelLoaded }
  };
};

export var loadSonicLibrary = function loadSonicLibrary() {
  var srePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/sre/";
  var sonicWorkerUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    type: SRE_LOAD_SONIC_LIBRARY,
    payload: { srePath: srePath, sonicWorkerUrl: sonicWorkerUrl }
  };
};
export var loadSpeechModel = function loadSpeechModel() {
  return { type: SRE_LOAD_SPEECH_MODEL };
};

export var showBrowserMicBlockModal = function showBrowserMicBlockModal() {
  var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    type: SRE_SHOW_BROWSER_MIC_BLOCK_MODAL,
    payload: { show: show }
  };
};
export var userAcknowledgesBrowserMicBlock = function userAcknowledgesBrowserMicBlock() {
  var choice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ACKNOWLEDGED_MIC_BLOCKED;
  return {
    type: SRE_USER_ACKNOWLEDGES_BROWSER_MIC_BLOCK_MODAL,
    payload: { choice: choice }
  };
};
export var userEnabledMicAccess = function userEnabledMicAccess() {
  var choice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FIXED_MIC_BLOCKED;
  return {
    type: SRE_USER_ACKNOWLEDGES_BROWSER_MIC_BLOCK_MODAL,
    payload: { choice: choice }
  };
};

export var enableAudioLog = function enableAudioLog(userId, appId) {
  var viperUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: ENABLE_AUDIO_LOG,
    payload: { userId: userId, appId: appId, viperUser: viperUser }
  };
};

export var setVersion = function setVersion(version) {
  return { type: SET_VERSION, payload: { version: version } };
};
export var skipMicCalibration = function skipMicCalibration() {
  return { type: SRE_SKIP_MIC_CALIBRATION, payload: {} };
};
export var sreResetRecentlySavedSoundLogIdsCache = function sreResetRecentlySavedSoundLogIdsCache() {
  return {
    type: SRE_RESET_RECENTLY_SAVED_SOUND_LOG_IDS_CACHE
  };
};